import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';
import { Notepad } from 'types';

export const getNotepad = async ( notepadId : number ): Promise<Notepad> => {
  const { data } = await axios.get(`/api/notepad/${notepadId}`);
  return data as Notepad;
};

type QueryFnType = typeof getNotepad;

type UseNotepadOptions = {
  notepadId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useNotepad = ({ notepadId, config }: UseNotepadOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['notepad', notepadId],
    queryFn: () => getNotepad(notepadId),
  });
};
